<!--<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" class="login-wrapper">
        <el-row type="flex" justify="center" align="center" v-show="visibility" style="height: 100%;">
            <el-col :span="8" class="row vertical-center">
                <el-form id="register_form" v-loading="loading"
                         :inline="false"
                         class="flex-1 register-form customize-label-top-form"
                         :rules="rules"
                         :model="formData"
                         :disabled="disableForm"
                         ref="registerForm">

                    <h3 class="text-center title"><label class="login-form-title">{{$t('register.formTitle')}}</label></h3>

                    <el-form-item prop="email" :label="$t('register.emailLabel')">

                        <el-input ref="email" type="email" @change="checkDisableSubmitButton" v-model="formData.email"
                                  :placeholder="$t('register.emailPlaceholder')"
                                  autocomplete="disabled"
                                  aria-autocomplete="none"></el-input>
                    </el-form-item>

                    <el-form-item id="password_wrapper" prop="password" :label="$t('register.passwordLabel')">
                        <el-input type="password" @change="checkDisableSubmitButton" v-model="formData.password"
                                  :placeholder="$t('register.passwordPlaceholder')"
                                  @keypress.enter.native="submitToConfirmEmail"></el-input>
                    </el-form-item>


                    <p class="comment-box cmt-box">
                        会員情報として利用するメールアドレスとパスワードをご入力ください。ご入力のメールアドレス宛て確認メールを送信します。
                        <br/>
                        【ご注意】「info@churanet-yoyaku.com」からのメール受信を許可してください。
                    </p>

                    <el-form-item class="bot-btn">
                        <el-button class="custom-button" style="width: 100%;" :disabled="disabledSubmitButton"
                                   v-on:click="submitToConfirmEmail">{{$t('register.submitButton')}}
                        </el-button>
                        <el-button class="custom-button-no-bg" style="width: 100%;margin-left: 0px;margin-top: 7px;"
                                   @click="toLoginPage">
                            {{$t('register.loginButton')}}
                        </el-button>
                    </el-form-item>

                </el-form>

            </el-col>
        </el-row>
    </div>
</template>-->

<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" class="register-wrapper">
        <el-row type="flex" justify="center" align="center" v-show="visibility" style="height: 100%;">
            <el-col class="row vertical-center" id="register_form_wrapper">
                <el-form id="register_form" v-loading="loading"
                         :inline="false"
                         class="flex-1 register-form customize-label-top-form"
                         :rules="rules"
                         :model="formData"
                         :disabled="disableForm"
                         ref="registerForm">

                    <h3 class="text-center title"><label class="login-form-title">{{$t('register.formTitle')}}</label>
                    </h3>

                    <el-form-item prop="email" :label="$t('register.emailLabel')">

                        <el-input ref="email" type="email" @change="checkDisableSubmitButton" v-model="formData.email"
                                  :placeholder="$t('register.emailPlaceholder')"
                                  autocomplete="disabled"
                                  aria-autocomplete="none"></el-input>
                    </el-form-item>

                    <el-form-item id="password_wrapper" prop="password" :label="$t('register.passwordLabel')">
                        <el-input type="password" @change="checkDisableSubmitButton" v-model="formData.password"
                                  :placeholder="$t('register.passwordPlaceholder')"
                                  @keypress.enter.native="submitToConfirmEmail"></el-input>
                    </el-form-item>


                    <p class="comment-box cmt-box">
                        会員情報として利用するメールアドレスとパスワードをご入力ください。ご入力のメールアドレス宛て確認メールを送信します。
                        <br/>
                        【ご注意】「info@chura-net-yoyaku.com」からのメール受信を許可してください。
                    </p>

                    <el-form-item class="bot-btn">
                        <el-button class="custom-button" style="width: 100%;" :disabled="disabledSubmitButton"
                                   v-on:click="submitToConfirmEmail">{{$t('register.submitButton')}}
                        </el-button>
                        <el-button class="custom-button-no-bg" style="width: 100%;margin-left: 0px;margin-top: 7px;"
                                   @click="toLoginPage">
                            {{$t('register.loginButton')}}
                        </el-button>
                    </el-form-item>

                </el-form>

            </el-col>
        </el-row>
    </div>
</template>

<script>
    import AlertService from "@/service/alert.service";
    import Pages from '@/router/Pages';
    import UserApi from '@/api/user/UserApi';
    import Utils from '@/util/index';

    export default {
        name: "Register",
        data() {
            let validatePassword = (rule, value, callback) => {
                console.log(Utils.isPasswordValid(value));
                if (!Utils.isPasswordValid(value)) {
                    callback(new Error(this.$t("common.invalidPasswordMessage")));
                }

                callback();
            };

            return {
                rules: {
                    email: [
                        {required: true, message: this.$t("common.requiredMessage"), trigger: "blur"},
                        {type: "email", message: this.$t('register.pleaseEnterExactlyFormatEmail'), trigger: "blur"},
                    ],
                    password: [
                        {required: true, message: this.$t("common.requiredMessage"), trigger: "blur"},
                        {validator: validatePassword, trigger: "blur"}
                    ]
                },

                formData: {
                    password: null,
                    email: null
                },

                disableForm: false,
                loading: false,
                visibility: true,
                fullscreenLoading: false,
                isShowNotificationCheckEmail: false,
                disabledSubmitButton: true,
            }
        },

        mounted() {
            this.$refs["email"].focus();
        },

        created() {
        },

        watch: {},

        methods: {
            checkDisableSubmitButton() {
                console.log("test")
                let email = this.formData.email;
                let password = this.formData.password;

                if (email == null && email.trim() == "") {
                    this.disabledSubmitButton = true;
                    return;

                } else {
                    if (!this.validateEmailFormat(email)) {
                        this.disabledSubmitButton = true;
                        return;
                    }
                }

                if (password == null || password.trim() == "" || !Utils.isPasswordValid(password)) {
                    this.disabledSubmitButton = true;
                    return;
                }

                this.disabledSubmitButton = false;
            },

            submitToConfirmEmail() {
                let vm = this;
                let email = vm.formData.email;
                let password = vm.formData.password;

                if (email == null || email.trim() == "") {
                    return;
                } else {
                    if (!vm.validateEmailFormat(email)) {
                        return;
                    }
                }

                if (password == null || password.trim() == "" || !Utils.isPasswordValid(password)) {
                    return;
                }

                this.loading = true;
                UserApi.checkUsernameWasUsed(email).then(result => {
                    this.loading = false;
                    console.log("Check username existed: " + result)
                    console.log(result)
                    if (result.usernameActive) {
                        AlertService.error(this.$t("register.emailWasUsedMessage"))
                        this.isShowNotificationCheckEmail = false;
                    } else {
                        if (result.confirmationUnexpired) {
                            AlertService.error(this.$t('register.emailWasSendButNotConfirmPassword'))
                        } else {
                            this.loading = true;
                            const confirmPwRequest = {
                                password: password
                            };
                            UserApi.sendEmailToConfirm(email, confirmPwRequest).then(result => {
                                console.log("Sending email to confirm...")
                                console.log(result)
                                this.loading = false;
                                this.$router.push({path: "/confirmSendEmailToRegisterAddress?endUserCode=" + result.endUserCode})

                            })
                        }
                    }
                })
            },

            validateEmailFormat(email) {
                let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            toLoginPage() {
                this.$router.push({path: Pages.login.path});
            },

            show() {
                this.visibility = true;
                this.disableForm = false;
            },

            hide() {
                this.visibility = false;
                this.disableForm = true;
            },

            next() {
                let vue = this;
                vue.$refs["registerForm"].validate(async valid => {
                    if (valid) {
                        try {

                        } catch (e) {
                            AlertService.error(this.$t("common.serverErrorMessage"), 2000);
                        } finally {
                            vue.loading = false;
                            vue.disableForm = false;
                        }
                    }
                });
            }
        }

    }
</script>

<style lang="scss" scoped>
    /deep/ .login-form-title {
        display: inline-block;
        padding-bottom: 5px;
    }

    .cmt-box {
        margin-top: 40px;
    }

    .title {

    }

    .bot-btn {
        margin-top: 30px;
    }

    .register-wrapper {
        height: 100%;
        margin-left: 35%;
        margin-right: 35%;
    }

    .register-form {
        border-radius: 50px;
        border: 1px solid #4B86E8;
        padding: 20px 40px;
    }

    #register_form_wrapper {

    }

    @media only screen and (max-height: 568px) {
        .register-wrapper {
            height: 100%;
            margin-left: 10%;
            margin-right: 10%;
        }

        #register_form {
            padding-left: 0px;
            padding-right: 0px;
        }

        #register_form {
            width: 100%;
            margin-top: -45px;
        }

        .bot-btn {
            margin-top: -5px;
        }

        .cmt-box {
            margin-top: 37px;
            padding-top: 5px;
            padding-bottom: 5px;
        }

        .title {
            height: 5px;
        }
    }

    @media only screen and (max-width: 1025px) {
        #register_form {
            width: 100%;
            border: none;
        }

        .register-wrapper {
            height: 100%;
            margin-left: 5%;
            margin-right: 5%;
        }

        #register_form {
            padding-left: 0px;
            padding-right: 0px;
        }
    }

    @media only screen and (max-width: 450px) {
        #register_form {
            width: 100%;
            border: none;
        }

        .vertical-center {
            width: 100%;
        }

        #password_wrapper {
            margin-top: 21px;
        }

        .register-wrapper {
            height: 100%;
            margin-left: 0%;
            margin-right: 0%;
        }

        #register_form {
            padding-left: 0px;
            padding-right: 0px;
        }
    }


</style>
